import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styled from 'styled-components';
import useStore from './pane-state-hook';

const Container = styled.div`
  &:not(.visible) {
    display: none;
  }
`;

export default function Pane({ children, eventKey }) {
  const expanded = useStore(React.useCallback(state => state.panesExpanded[eventKey], [eventKey]));

  return (
    <Container className={classNames({ visible: expanded })}>
      {children}
    </Container>
  );
}

Pane.propTypes = {
  children: PropTypes.node.isRequired,
  eventKey: PropTypes.string.isRequired,
};
